export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10083.e7a98167.jpg";